import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		DphSazba: [],
		OpaVaria: [],
		Pouzitel: [],
		Pujcovna: [],
		Skladost: [],
		Stav: [],
	},
	filter: {
		DphSzbOzn: null as number | null,
		OpaVariaList: null as number[] | null,
		OstatniNr: null as string | null,
		PcDo: null as number | null,
		PcOd: null as number | null,
		PouzitelPzn: null as number | null,
		PrioritaDo: null as number | null,
		PrioritaOd: null as number | null,
		Pujcene: null as boolean | null,
		PujcovnaId: null as number | null,
		SkladmistoostId: null as number | null,
		SkladmistoostIdText: null as string | null,
		SkladmistoostIdPopis: null as string | null,
		SkladostOzn: null as number | null,
		StavPzn: null as number | null,
		Text: null as string | null,
		VstupDatDo: null as string | null,
		VstupDatOd: null as string | null,
		VstupPracId: null as number | null,
		VstupPracOsobniCis: null as string | null,
		VstupPracIdText: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.VSTUP_PRAC_SELECT_MAPPER](state, { data }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
		[listMutations.SKLAD_MISTO_PREDMETU_SELECT_MAPPER](state, { data }) {
			state.filter.SkladmistoostId = data.id;
			state.filter.SkladmistoostIdText = data.value;
			state.filter.SkladmistoostIdPopis = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
